import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';


import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { authInterceptor } from './modules/shared/interceptors/auth.interceptor';
import { EnsureSecondsPipe } from './modules/shared/pipes/ensure-seconds.pipe';
import { SocketConfigModule } from './socket.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideAnimations(), // required animations providers
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideToastr(),
    EnsureSecondsPipe,
    importProvidersFrom(SocketConfigModule),

  ]
};
